import {
  SET_TIN_CHAP_EDIT,
  SET_CONFIG_TM_TIN_CHAP,
  SHOW_FORM_TIN_CHAP,
  GET_CONFIG_SYS_TMTC,
  POST_TIN_CHAP,
  POST_TIN_CHAP_SUCCESS,
  POST_TIN_CHAP_FAILURE,
  CHECK_EDIT_TIN_CHAP,
  CHECK_EDIT_CUSTOMER_TC,
  SET_ENABLE_EDIT_TIN_CHAP,
  SET_ENABLE_EDIT_CUSTOMER_TC,
  SET_TAI_SAN_TC,
  GET_TAI_SAN_THEO_CHO_VAY_TMTC,
} from "./actionTypes";

export const setChoVayEdit = (dataEdit) => ({
  type: SET_TIN_CHAP_EDIT,
  payload: dataEdit,
});

export const setConfig = (data) => ({
  type: SET_CONFIG_TM_TIN_CHAP,
  payload: data,
});

export const showFormTinChap = (data) => {
  return {
    type: SHOW_FORM_TIN_CHAP,
    payload: data,
  };
};
export const getConfigSysTMTC = (dataSearch) => ({
  type: GET_CONFIG_SYS_TMTC,
  dataSearch,
});
export const postTinChap = (dataPost) => ({
  type: POST_TIN_CHAP,
  dataPost,
});

export const postTinChapSuccess = (data) => ({
  type: POST_TIN_CHAP_SUCCESS,
  payload: data,
});

export const postTinChapFailure = () => ({
  type: POST_TIN_CHAP_FAILURE,
});

export const checkEditChoVay = (choVayId) => ({
  type: CHECK_EDIT_TIN_CHAP,
  choVayId,
});
export const setEnableEditChoVay = (data) => ({
  type: SET_ENABLE_EDIT_TIN_CHAP,
  payload: data,
});

export const checkEditCustomer = (customerId) => ({
  type: CHECK_EDIT_CUSTOMER_TC,
  customerId,
});
export const setEnableEditCustomer = (data) => ({
  type: SET_ENABLE_EDIT_CUSTOMER_TC,
  payload: data,
});
export const setTaiSanTinChap = (data) => ({
  type: SET_TAI_SAN_TC,
  payload: data,
});
export const getTaiSanTheoChoVayTMTC = (dataSearch) => ({
  type: GET_TAI_SAN_THEO_CHO_VAY_TMTC,
  dataSearch,
});
